import {
  RatingConfigurator,
  MultipleSelectionConfigurator,
  EmailConfigurator,
  CommentConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const AssetLibraryAIGCMVPSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'AssetLibraryAIGCSurvey',
    style: {
      root: {
        minWidth: 600,
        maxWidth: 600,
      },
    },
    others: {
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with the feature of generating images through AI?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neutral')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    email: {
      Type: EmailConfigurator,
      key: 'email',
      page: 1,
      position: 2,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes - specify the contact email below')),
          placeholder: i18n.getString(_TL_('Enter your email')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
    questions: [
      {
        isRequired: true,
        Type: MultipleSelectionConfigurator,
        key: 'q1',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Would you tell us more about why you are not so satisfied with the AI-generated image feature?')),
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('Generated images are not attractive enough')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('Generated images contain sensitive information')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('Generated images are not relevant to my business')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('I have a hard time describing the images I want')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Others - please specify')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 1024,
          },
        ],
        data: {
        },
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q2',
        page: 1,
        position: 1,
        getTitle: () => i18n.getString(_TL_('How can we continue to improve?')),
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
        maxLength: 1024,
        data: {
        },
      },
    ],
  };
};
